









































































































































import IProductDto from "@/chipply/i-product-dto";
import Component from "vue-class-component";
import Vue from "vue";
import { Inject, Prop, Watch } from "vue-property-decorator";
import IPackageDto from "@/chipply/i-package-dto";
import { Utils } from "chipply-common";
import PackageDesignFlag from "./PackageDesignFlag.vue";
import ProductImageSlider from "@/components/design-elements/ProductImageSlider.vue";
import { PackageHelper } from "@/chipply/view-model/PackageHelper";
import { EventBus } from "@/chipply/EventBus";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: {
        ProductImageSlider,
        PackageDesignFlag,
    },
})
export default class StorePackage extends Vue {
    public Utils = Utils;
    public helper = new PackageHelper();
    public packageID!: number;
    public disablePackageButton = false;

    public $refs!: {
        packageProducts: Vue;
    };

    @Prop({
        default: "",
        type: String,
    })
    public foregroundColor!: string;

    @Prop({
        default: "",
        type: String,
    })
    public backgroundColor!: string;

    @Prop({
        default: "",
        type: String,
    })
    public eventID!: string;

    @Prop({
        type: Object,
    })
    public packageDto!: IPackageDto;

    @Inject()
    private priceDisplay!: IPriceDisplay;

    //listen for 'load' event coming from ProductDisplayCard to control timing of scroll to package after product cards load
    public mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        EventBus.$on("load", () => {
            const selectedPackageID = parseInt(urlParams.get("acid") || "0");
            if (selectedPackageID) {
                this.tryFocus(selectedPackageID);
            }
        });
        if (this.packageDto.hasGroupProducts) {
            this.checkGroupProductColors();
        }
    }

    public beforeDestroy() {
        EventBus.$off("load");
    }

    public checkGroupProductColors() {
        for (const model of this.packageDto.products.products) {
            if (model.isStoreProductGroup && !model.allGroupProductsHaveColors) {
                this.disablePackageButton = true;
            }
        }
    }

    public get packagePriceDisplay() {
        if (!this.packageDto) {
            return [];
        }
        return this.helper.determineZeroSellPriceDisplay(this.packageDto, this.priceDisplay);
    }

    public imagesShown() {
        if (this.$vuetify.breakpoint.smAndUp) {
            return 5;
        } else {
            return 3;
        }
    }

    public getProductName(product: IProductDto) {
        let productDisplay = "";
        if (product.isStoreProductGroup) {
            productDisplay = product.storeProductGroupName;
            return productDisplay;
        }
        if (!product.hideVendor) {
            productDisplay += product.vendorName;
        }
        if (!product.hideStyle) {
            if (productDisplay.length > 0) {
                productDisplay += " - ";
            }
            productDisplay += product.sku;
        }

        if (!product.hideProductName) {
            if (productDisplay.length > 0) {
                productDisplay += " - ";
            }

            productDisplay += product.productName;
        }

        return productDisplay;
    }

    //navigateToPackage() adds &lastaction=viewall to the URL params if user came from action=viewall page so that we can navigate back to that with returnToStoreUrl()
    public navigateToPackage() {
        if (this.disablePackageButton) {
            return;
        }
        let navigationUrl = "package-detail-shell.aspx?eid=" + this.eventID + "&cid=" + this.packageDto.eventCategoryID;
        let currentUrl = window.location.href;
        let historyUrl = new URL(currentUrl);
        if (historyUrl.searchParams.has("action")) {
            navigationUrl += "&lastaction=viewall";
        }
        window.location.href = navigationUrl;

        if (!historyUrl.searchParams.has("eid")) {
            historyUrl.searchParams.set("eid", this.eventID.toString());
        } else {
            historyUrl.searchParams.delete("eid");
            historyUrl.searchParams.set("eid", this.eventID.toString());
        }

        if (!historyUrl.searchParams.has("acid") && this.packageDto) {
            historyUrl.searchParams.set("acid", this.packageDto.eventCategoryID.toString());
        } else {
            historyUrl.searchParams.delete("acid");
            if (this.packageDto) {
                historyUrl.searchParams.set("acid", this.packageDto.eventCategoryID.toString());
            }
        }

        history.replaceState(null, "", historyUrl.href);
    }

    private tryFocus(selectedPackageID?: number) {
        const shouldFocus = this.packageDto.eventCategoryID === selectedPackageID;
        if (!shouldFocus) {
            return;
        }

        Vue.nextTick(() => {
            if (selectedPackageID && this.packageDto.eventCategoryID === selectedPackageID) {
                this.$refs.packageProducts.$el.scrollIntoView();
                this.$emit("scroll");
                return;
            }
        });
    }
}
